import { INDRAFlightPrice } from '@ibe.models/flight-price.model.indra.lib';
import { INDRACurrencyService } from '@ibe.services/currency.indra.service';
import { TRIP_TYPE_MULTICITY_CODE } from '@ibe.config';
import { INDRABFMDataStorageService } from './bfm-data-storage.indra.service';
import { INDRAStorageService } from './storage.indra.service';
import { Router } from '@angular/router';
import { DISCOUNT_TYPE_VOUCHER, DISCOUNT_TYPE_PROMOCODE, DISCOUNT_TYPE_OTHERS, DISCOUNT_AMOUNT_TYPE_FIXED, DISCOUNT_AMOUNT_TYPE_PERCENTAGE, DISCOUNT_APPLY_TO_FARE, DISCOUNT_APPLY_TO_TOTAL, DISCOUNT_APPLY_TO_YQ, EXTRAS_ANCILLARY_CAR, EXTRAS_ANCILLARY_INSURANCE, EXTRAS_ANCILLARY_GUARANTEE_FUND, EXTRAS_ANCILLARY_CARBON_OFFSET } from '@ibe.config';
import * as i0 from "@angular/core";
import * as i1 from "./currency.indra.service";
import * as i2 from "./bfm-data-storage.indra.service";
import * as i3 from "./storage.indra.service";
import * as i4 from "@angular/router";
var INDRAFlightPriceService = /** @class */ (function () {
    function INDRAFlightPriceService(currencyService, bfmStorage, storage, router) {
        this.currencyService = currencyService;
        this.bfmStorage = bfmStorage;
        this.storage = storage;
        this.router = router;
        this.flightFareBreakdown = {};
    }
    INDRAFlightPriceService.prototype.INDRA_getFlightTotalCost = function (selectedFlight, tripType, isBookAwardFlights) {
        var cashPrice = 0;
        var milesPrice = 0;
        var tax = 0;
        var selectedFlights = [selectedFlight];
        var currencyUnit = this.currencyService.INDRA_getCurrencySymbol().unit;
        if (isBookAwardFlights) {
            milesPrice = this.computeSelectedFlightsTotalPrice(selectedFlights, tripType, isBookAwardFlights);
            tax = this.computeSelectedFlightsTotalTax(selectedFlights, tripType, isBookAwardFlights);
            return new INDRAFlightPrice(milesPrice, tax, currencyUnit, true).getFlightCost();
        }
        else {
            cashPrice = this.computeSelectedFlightsTotalPrice(selectedFlights, tripType, isBookAwardFlights);
            return new INDRAFlightPrice(cashPrice, 0, currencyUnit, false).getFlightCost();
        }
    };
    INDRAFlightPriceService.prototype.INDRA_getSelectedFlightsTotalCost = function (selectedFlights, tripType, isBookAwardFlights) {
        var cashPrice = 0;
        var milesPrice = 0;
        var tax = 0;
        var currencyUnit = this.currencyService.INDRA_getCurrencySymbol().unit;
        if (isBookAwardFlights) {
            milesPrice = this.computeSelectedFlightsTotalPrice(selectedFlights, tripType, isBookAwardFlights);
            tax = this.computeSelectedFlightsTotalTax(selectedFlights, tripType, isBookAwardFlights);
            return new INDRAFlightPrice(milesPrice, tax, currencyUnit, true).getFlightCost();
        }
        else {
            cashPrice = this.computeSelectedFlightsTotalPrice(selectedFlights, tripType, isBookAwardFlights);
            return new INDRAFlightPrice(cashPrice, 0, currencyUnit, false).getFlightCost();
        }
    };
    // get total ancillary cost
    INDRAFlightPriceService.prototype.INDRA_getTotalAncillaryCost = function (ancillaries, stopoverExtras, excludeNotVoucherDiscountableAncillaries) {
        if (excludeNotVoucherDiscountableAncillaries === void 0) { excludeNotVoucherDiscountableAncillaries = false; }
        var ancillariesTotal = 0;
        var stopoverExtrasTotal = 0;
        var activeBooking = this.bfmStorage.INDRA_getActiveBookedTrip();
        if (ancillaries) {
            for (var i in ancillaries.itemsAdded) {
                if (!ancillaries.itemsAdded[i].payWithMiles) {
                    ancillariesTotal = parseFloat(ancillaries.itemsAdded[i].price) + ancillariesTotal;
                }
            }
        }
        // exclude ancillaries not discountable using vouchers
        var excludeAncillaries = [];
        if (excludeNotVoucherDiscountableAncillaries) {
            excludeAncillaries.push(EXTRAS_ANCILLARY_CAR);
            excludeAncillaries.push(EXTRAS_ANCILLARY_INSURANCE);
            excludeAncillaries.push(EXTRAS_ANCILLARY_GUARANTEE_FUND);
            excludeAncillaries.push(EXTRAS_ANCILLARY_CARBON_OFFSET);
        }
        var thirdPartyAncillariesTotal = this.INDRA_getThirdPartyAncillaries(activeBooking, excludeAncillaries);
        ancillariesTotal = ancillariesTotal + thirdPartyAncillariesTotal;
        if (stopoverExtras.length > 0) {
            for (var i in stopoverExtras) {
                stopoverExtrasTotal = stopoverExtrasTotal + stopoverExtras[i].value;
            }
            ancillariesTotal = ancillariesTotal + stopoverExtrasTotal;
        }
        return ancillariesTotal;
    };
    INDRAFlightPriceService.prototype.INDRA_getBookingTotalCost = function (selectedFlights, tripType, isBookAwardFlights, excludeMilesGo, promocodesAndVouchers, bookedTripDiscounts, weakFlightsDiscount, ancillaries, stopoverExtras, surchargeAmount) {
        var cashPrice = 0;
        var milesPrice = 0;
        var tax = 0;
        var currencyUnit = this.currencyService.INDRA_getCurrencySymbol().unit;
        var decimalPlaceCount = this.currencyService.INDRA_getDecimalPlaces();
        var milesAndGoDiscount = excludeMilesGo ? [] : bookedTripDiscounts;
        var ancillariesPriceVoucherApplicable = this.INDRA_getTotalAncillaryCost(ancillaries, stopoverExtras, true); // get all except third party ancillaries
        var ancillariesPriceVoucherNotApplicable = this.INDRA_getTotalAncillaryCost(null, [], false); // get only third party ancillaries
        if (isBookAwardFlights) {
            milesPrice = this.computeSelectedFlightsTotalPrice(selectedFlights, tripType, isBookAwardFlights);
            tax = this.computeSelectedFlightsTotalTax(selectedFlights, tripType, isBookAwardFlights);
            var otherChargesTotal = this.INDRA_getOtherChargesTotal();
            var voucherDiscount = this.getDiscountTotalByType(DISCOUNT_TYPE_VOUCHER, null, null, promocodesAndVouchers, null, null, isBookAwardFlights, 0, 0);
            /*
            const cashDiscount = this.getDiscountTotalByType(
                DISCOUNT_TYPE_OTHERS, null, null, null, milesAndGoDiscount, weakFlightsDiscount, isBookAwardFlights, 0, 0);
            */
            var milesDiscount = this.getDiscountTotalByType(DISCOUNT_TYPE_PROMOCODE, DISCOUNT_AMOUNT_TYPE_FIXED, DISCOUNT_APPLY_TO_TOTAL, promocodesAndVouchers, null, null, isBookAwardFlights, milesPrice, 0) +
                this.getDiscountTotalByType(DISCOUNT_TYPE_PROMOCODE, DISCOUNT_AMOUNT_TYPE_PERCENTAGE, DISCOUNT_APPLY_TO_TOTAL, promocodesAndVouchers, null, null, isBookAwardFlights, milesPrice, 0) +
                this.getDiscountTotalByType(DISCOUNT_TYPE_PROMOCODE, DISCOUNT_AMOUNT_TYPE_FIXED, DISCOUNT_APPLY_TO_FARE, promocodesAndVouchers, null, null, isBookAwardFlights, milesPrice, 0) +
                this.getDiscountTotalByType(DISCOUNT_TYPE_PROMOCODE, DISCOUNT_AMOUNT_TYPE_PERCENTAGE, DISCOUNT_APPLY_TO_FARE, promocodesAndVouchers, null, null, isBookAwardFlights, milesPrice, 0);
            tax = (tax + ancillariesPriceVoucherApplicable + otherChargesTotal) - voucherDiscount;
            tax = tax >= 0 ? tax : 0;
            tax = tax + ancillariesPriceVoucherNotApplicable;
            var ancillariesPriceMiles = this.INDRA_getAncillariesPaidWithMiles(ancillaries).miles;
            milesPrice = (milesPrice - milesDiscount >= 0) ? milesPrice - milesDiscount : 0;
            milesPrice = milesPrice + ancillariesPriceMiles;
            return new INDRAFlightPrice(milesPrice, tax, currencyUnit, true).getFlightCost();
        }
        else {
            var flightPrice = this.computeSelectedFlightsTotalPrice(selectedFlights, tripType, isBookAwardFlights);
            tax = this.computeSelectedFlightsTotalTax(selectedFlights, tripType, isBookAwardFlights);
            var flightFare = flightPrice - tax;
            var otherChargesTotal = this.INDRA_getOtherChargesTotal();
            var voucherDiscount = this.getDiscountTotalByType(DISCOUNT_TYPE_VOUCHER, null, null, promocodesAndVouchers, null, null, isBookAwardFlights, 0, 0);
            var cashDiscountsFare = this.getDiscountTotalByType(DISCOUNT_TYPE_PROMOCODE, DISCOUNT_AMOUNT_TYPE_FIXED, DISCOUNT_APPLY_TO_FARE, promocodesAndVouchers, null, null, isBookAwardFlights, flightFare, tax) +
                this.getDiscountTotalByType(DISCOUNT_TYPE_PROMOCODE, DISCOUNT_AMOUNT_TYPE_PERCENTAGE, DISCOUNT_APPLY_TO_FARE, promocodesAndVouchers, null, null, isBookAwardFlights, flightFare, tax);
            var cashDiscountsFlightTotalPrice = this.getDiscountTotalByType(DISCOUNT_TYPE_PROMOCODE, DISCOUNT_AMOUNT_TYPE_FIXED, DISCOUNT_APPLY_TO_TOTAL, promocodesAndVouchers, null, null, isBookAwardFlights, flightFare, tax) +
                this.getDiscountTotalByType(DISCOUNT_TYPE_PROMOCODE, DISCOUNT_AMOUNT_TYPE_PERCENTAGE, DISCOUNT_APPLY_TO_TOTAL, promocodesAndVouchers, null, null, isBookAwardFlights, flightFare, tax);
            var cashDiscountsYQTax = this.getDiscountTotalByType(DISCOUNT_TYPE_PROMOCODE, DISCOUNT_AMOUNT_TYPE_FIXED, DISCOUNT_APPLY_TO_YQ, promocodesAndVouchers, null, null, isBookAwardFlights, flightFare, tax) +
                this.getDiscountTotalByType(DISCOUNT_TYPE_PROMOCODE, DISCOUNT_AMOUNT_TYPE_PERCENTAGE, DISCOUNT_APPLY_TO_YQ, promocodesAndVouchers, null, null, isBookAwardFlights, flightFare, tax);
            var otherDiscounts = this.getDiscountTotalByType(DISCOUNT_TYPE_OTHERS, null, null, null, milesAndGoDiscount, weakFlightsDiscount, isBookAwardFlights, 0, 0);
            // apply fare cash discount to flight fare
            cashPrice = (flightFare - cashDiscountsFare) >= 0 ? (flightFare - cashDiscountsFare) : 0;
            // apply flight total (fare + tax) discount to flight total
            cashPrice = cashPrice + tax;
            cashPrice = cashPrice - (cashDiscountsFlightTotalPrice + cashDiscountsYQTax + otherDiscounts) >= 0 ? (cashPrice - (cashDiscountsFlightTotalPrice + cashDiscountsYQTax + otherDiscounts)) : 0;
            // apply voucher discount to flight price
            cashPrice = (cashPrice + otherChargesTotal + ancillariesPriceVoucherApplicable) - voucherDiscount;
            cashPrice = cashPrice >= 0 ? cashPrice : 0;
            cashPrice = cashPrice + ancillariesPriceVoucherNotApplicable;
            // apply surcharge amount to flight cost if surcharge amount is present, final cash price is not zero and flight cost was not fully covered by discounts
            if (surchargeAmount > 0 /* && cashPrice > 0 */) {
                cashPrice = cashPrice + surchargeAmount;
            }
            var totalPriceCash = new INDRAFlightPrice(cashPrice, 0, currencyUnit, false).getFlightCost();
            var totalPriceCashStr = totalPriceCash.substring(0, totalPriceCash.indexOf(' '));
            return totalPriceCash;
        }
    };
    INDRAFlightPriceService.prototype.INDRA_getDiscountsTotal = function (promocodesAndVouchers, bookedTripDiscounts, weakFlightsDiscount, selectedFlights, tripType, isBookAwardFlights, currency) {
        var flightPrice = 0;
        var flightFare = 0;
        var flightTax = 0;
        if (selectedFlights && selectedFlights.length > 0) {
            flightPrice = this.computeSelectedFlightsTotalPrice(selectedFlights, tripType, isBookAwardFlights);
            flightTax = this.computeSelectedFlightsTotalTax(selectedFlights, tripType, isBookAwardFlights);
            flightFare = isBookAwardFlights ? flightFare : (flightPrice - flightTax);
        }
        var totalDiscount = this.computeDiscountsTotal(promocodesAndVouchers, bookedTripDiscounts, weakFlightsDiscount, flightFare, flightTax);
        var totalMiles = this.computeMilesDiscountsTotal(promocodesAndVouchers, bookedTripDiscounts, weakFlightsDiscount, flightPrice);
        var cashPart = '';
        var milesPart = totalMiles > 0 ? totalMiles.toFixed(0) + " M" : '';
        if (totalDiscount > 0 && totalMiles > 0) {
            cashPart = "+ " + totalDiscount.toFixed(2) + " " + (currency ? currency : this.currencyService.INDRA_getCurrencySymbol().unit);
        }
        else if (totalDiscount > 0 && totalMiles <= 0) {
            cashPart = totalDiscount.toFixed(2) + " " + (currency ? currency : this.currencyService.INDRA_getCurrencySymbol().unit);
        }
        else {
            cashPart = '';
        }
        return milesPart + " " + cashPart;
    };
    INDRAFlightPriceService.prototype.INDRA_computeBookingCashTotal = function (selectedFlights, tripType, isBookAwardFlights, excludeMilesGo, promocodesAndVouchers, bookedTripDiscounts, weakFlightsDiscount, ancillaries, webAdminFee, stopoverExtras, surchargeAmount) {
        var decimalPlaceCount = this.currencyService.INDRA_getDecimalPlaces();
        var cashPrice = 0;
        var milesAndGoDiscount = excludeMilesGo ? [] : bookedTripDiscounts;
        var ancillariesPriceVoucherApplicable = this.INDRA_getTotalAncillaryCost(ancillaries, stopoverExtras, true); // get all except third party ancillaries
        var ancillariesPriceVoucherNotApplicable = this.INDRA_getTotalAncillaryCost(null, [], false); // get only third party ancillaries
        // discountType, amountType, applyTo, promocodesAndVouchers, bookedTripDiscounts, weakFlightsDiscount, isBookAwardFlights, flightFare, flightTax
        if (isBookAwardFlights) {
            var tax = this.computeSelectedFlightsTotalTax(selectedFlights, tripType, isBookAwardFlights);
            var voucherDiscount = this.getDiscountTotalByType(DISCOUNT_TYPE_VOUCHER, null, null, promocodesAndVouchers, null, null, isBookAwardFlights, 0, 0);
            /*
            const cashDiscounts = this.getDiscountTotalByType(
                DISCOUNT_TYPE_OTHERS, null, null, null, milesAndGoDiscount, weakFlightsDiscount, isBookAwardFlights, 0, 0);
            const discountableAmount =
                ((ancillariesPrice +  webAdminFee) - cashDiscounts >= 0) ? ((ancillariesPrice +  webAdminFee) - cashDiscounts) : 0;
            cashPrice = tax + discountableAmount;
            */
            cashPrice = tax;
            cashPrice = (cashPrice + webAdminFee + ancillariesPriceVoucherApplicable) - voucherDiscount;
            cashPrice = cashPrice >= 0 ? cashPrice : 0;
            cashPrice = cashPrice + ancillariesPriceVoucherNotApplicable;
            return (decimalPlaceCount > 0 ? cashPrice.toFixed(2) : this.removeDecimalPlaces(cashPrice.toString()));
        }
        else {
            var flightPrice = this.computeSelectedFlightsTotalPrice(selectedFlights, tripType, isBookAwardFlights);
            var tax = this.computeSelectedFlightsTotalTax(selectedFlights, tripType, isBookAwardFlights);
            var flightFare = flightPrice - tax;
            var voucherDiscount = this.getDiscountTotalByType(DISCOUNT_TYPE_VOUCHER, null, null, promocodesAndVouchers, null, null, isBookAwardFlights, 0, 0);
            var cashDiscountsFare = this.getDiscountTotalByType(DISCOUNT_TYPE_PROMOCODE, DISCOUNT_AMOUNT_TYPE_FIXED, DISCOUNT_APPLY_TO_FARE, promocodesAndVouchers, null, null, isBookAwardFlights, flightFare, tax) +
                this.getDiscountTotalByType(DISCOUNT_TYPE_PROMOCODE, DISCOUNT_AMOUNT_TYPE_PERCENTAGE, DISCOUNT_APPLY_TO_FARE, promocodesAndVouchers, null, null, isBookAwardFlights, flightFare, tax);
            var cashDiscountsFlightTotalPrice = this.getDiscountTotalByType(DISCOUNT_TYPE_PROMOCODE, DISCOUNT_AMOUNT_TYPE_FIXED, DISCOUNT_APPLY_TO_TOTAL, promocodesAndVouchers, null, null, isBookAwardFlights, flightFare, tax) +
                this.getDiscountTotalByType(DISCOUNT_TYPE_PROMOCODE, DISCOUNT_AMOUNT_TYPE_PERCENTAGE, DISCOUNT_APPLY_TO_TOTAL, promocodesAndVouchers, null, null, isBookAwardFlights, flightFare, tax);
            var cashDiscountsYQTax = this.getDiscountTotalByType(DISCOUNT_TYPE_PROMOCODE, DISCOUNT_AMOUNT_TYPE_FIXED, DISCOUNT_APPLY_TO_YQ, promocodesAndVouchers, null, null, isBookAwardFlights, flightFare, tax) +
                this.getDiscountTotalByType(DISCOUNT_TYPE_PROMOCODE, DISCOUNT_AMOUNT_TYPE_PERCENTAGE, DISCOUNT_APPLY_TO_YQ, promocodesAndVouchers, null, null, isBookAwardFlights, flightFare, tax);
            var otherDiscounts = this.getDiscountTotalByType(DISCOUNT_TYPE_OTHERS, null, null, null, milesAndGoDiscount, weakFlightsDiscount, isBookAwardFlights, 0, 0);
            // apply fare cash discount to flight fare
            cashPrice = (flightFare - cashDiscountsFare) >= 0 ? (flightFare - cashDiscountsFare) : 0;
            // apply flight total (fare + tax) discount to flight total
            cashPrice = cashPrice + tax;
            cashPrice = cashPrice - (cashDiscountsFlightTotalPrice + cashDiscountsYQTax + otherDiscounts) >= 0 ? (cashPrice - (cashDiscountsFlightTotalPrice + cashDiscountsYQTax + otherDiscounts)) : 0;
            // apply voucher discount to the flight price
            cashPrice = (cashPrice + webAdminFee + ancillariesPriceVoucherApplicable) - voucherDiscount >= 0 ? (cashPrice + webAdminFee + ancillariesPriceVoucherApplicable) - voucherDiscount : 0;
            cashPrice = cashPrice + ancillariesPriceVoucherNotApplicable;
            // apply surcharge amount to flight cost if surcharge amount is present, final cash price is not zero and flight cost was not fully covered by discounts
            if (surchargeAmount > 0 /*&& cashPrice > 0*/) {
                cashPrice = cashPrice + surchargeAmount;
            }
            return (decimalPlaceCount > 0 ? cashPrice.toFixed(2) : this.removeDecimalPlaces(cashPrice.toString()));
        }
    };
    /*
    // get surcharge amount (applicable only on commercial flights and without miles & go discount 2 applied)
    INDRA_getSurchargeAmountNoFlightMilesDiscount(selectedFlights: any[], tripType: string, isBookAwardFlights: boolean, excludeMilesGo: boolean,
        promocodesAndVouchers: any[], bookedTripDiscounts: any [], weakFlightsDiscount, surcharge: any) {
        
        const milesAndGoDiscount = excludeMilesGo ? [] : bookedTripDiscounts;

        const flightPrice = this.computeSelectedFlightsTotalPrice(selectedFlights, tripType, false);
        
        const tax = this.computeSelectedFlightsTotalTax(selectedFlights, tripType, isBookAwardFlights);
        const flightFare = flightPrice - tax;
        
        const voucherDiscount = this.getDiscountTotalByType(
            DISCOUNT_TYPE_VOUCHER, null, null, promocodesAndVouchers, null, null, isBookAwardFlights, 0, 0);
        
        const cashDiscountsFare =
            this.getDiscountTotalByType(DISCOUNT_TYPE_PROMOCODE, DISCOUNT_AMOUNT_TYPE_FIXED, DISCOUNT_APPLY_TO_FARE,
                promocodesAndVouchers, null, null, isBookAwardFlights, flightFare, tax) +
            this.getDiscountTotalByType(DISCOUNT_TYPE_PROMOCODE, DISCOUNT_AMOUNT_TYPE_PERCENTAGE, DISCOUNT_APPLY_TO_FARE,
                promocodesAndVouchers, null, null, isBookAwardFlights, flightFare, tax);
                
        const cashDiscountsFlightTotalPrice =
            this.getDiscountTotalByType(DISCOUNT_TYPE_PROMOCODE, DISCOUNT_AMOUNT_TYPE_FIXED, DISCOUNT_APPLY_TO_TOTAL,
                promocodesAndVouchers, null, null, isBookAwardFlights, flightFare, tax) +
            this.getDiscountTotalByType(DISCOUNT_TYPE_PROMOCODE, DISCOUNT_AMOUNT_TYPE_PERCENTAGE, DISCOUNT_APPLY_TO_TOTAL,
                promocodesAndVouchers, null, null, isBookAwardFlights, flightFare, tax);
                
        const cashDiscountsYQTax = this.getDiscountTotalByType(DISCOUNT_TYPE_PROMOCODE, DISCOUNT_AMOUNT_TYPE_FIXED, DISCOUNT_APPLY_TO_YQ,
                promocodesAndVouchers, null, null, isBookAwardFlights, flightFare, tax) +
            this.getDiscountTotalByType(DISCOUNT_TYPE_PROMOCODE, DISCOUNT_AMOUNT_TYPE_PERCENTAGE, DISCOUNT_APPLY_TO_YQ,
                promocodesAndVouchers, null, null, isBookAwardFlights, flightFare, tax);
        
        const otherDiscounts = this.getDiscountTotalByType(
            DISCOUNT_TYPE_OTHERS, null, null, null, milesAndGoDiscount, weakFlightsDiscount, isBookAwardFlights, 0, 0);
        
        // apply fare cash discount to flight fare
        let cashPrice = (flightFare - cashDiscountsFare) >= 0 ? (flightFare - cashDiscountsFare) : 0;
        
        // apply flight total (fare + tax) discount to flight total
        cashPrice = cashPrice + tax;
        cashPrice = cashPrice - (cashDiscountsFlightTotalPrice + cashDiscountsYQTax + otherDiscounts) >= 0 ? (cashPrice - (cashDiscountsFlightTotalPrice + cashDiscountsYQTax + otherDiscounts)) : 0;
        
        // check if flight cost is fully covered by discounts
        const remainingFlightPrice = cashPrice - voucherDiscount;

        let surchargeAmount = 0;
        if (surcharge && remainingFlightPrice > 0) {
            surchargeAmount = remainingFlightPrice * (surcharge / 100);
        }
        return surchargeAmount;
    }
    
    // get surcharge amount (applicable only on commercial flights and with miles & go discount applied)
    INDRA_getSurchargeAmountWithFlightMilesDiscount(selectedFlights: any[], tripType: string, milesCashDiscount: any, surcharge: any) {
        if (surcharge == 0) return 0;
        const origFlightPrice = this.computeSelectedFlightsTotalPrice(selectedFlights, tripType, false);
        if (milesCashDiscount > 0 && (origFlightPrice - milesCashDiscount) > 0) {
            return (origFlightPrice - milesCashDiscount) * (surcharge / 100);
        } else {
            return 0;
        }
    }
    */
    // NOTE currently not used. If this is to be used, miles discount computation must be added
    INDRAFlightPriceService.prototype.INDRA_computeBookingPointsTotal = function (selectedFlights, tripType, isBookAwardFlights) {
        return this.computeSelectedFlightsTotalPrice(selectedFlights, tripType, true);
    };
    INDRAFlightPriceService.prototype.hasDiscounts = function (promocodesAndVouchers, bookedTripDiscounts, weakFlightsDiscount) {
        if ((promocodesAndVouchers && promocodesAndVouchers.length > 0) ||
            (bookedTripDiscounts && bookedTripDiscounts.length > 0) ||
            weakFlightsDiscount) {
            return true;
        }
        else {
            return false;
        }
    };
    INDRAFlightPriceService.prototype.computeSelectedFlightsTotalPrice = function (selectedFlights, tripType, isBookAwardFlights) {
        var totalCost = 0;
        if (isBookAwardFlights) {
            if (tripType === TRIP_TYPE_MULTICITY_CODE) {
                totalCost = selectedFlights.map(function (flight) { return flight.options.price; }).reduce(function (a, b) { return a + b; });
            }
            else {
                totalCost = selectedFlights.map(function (flight) {
                    var bound = flight.bound;
                    return flight.options.brand.offer[bound].totalPoints.price;
                }).reduce(function (a, b) { return a + b; });
            }
            return totalCost;
        }
        else {
            totalCost = selectedFlights.map(function (flight) { return flight.options.price; }).reduce(function (a, b) { return a + b; });
            return totalCost;
        }
    };
    INDRAFlightPriceService.prototype.computeSelectedFlightsTotalTax = function (selectedFlights, tripType, isBookAwardFlights) {
        var totalTax = 0;
        if (isBookAwardFlights) {
            if (tripType === TRIP_TYPE_MULTICITY_CODE) {
                totalTax = selectedFlights.map(function (flight) {
                    return (flight.options.tax + flight.options.obFee);
                }).reduce(function (a, b) { return a + b; });
            }
            else {
                totalTax = selectedFlights.map(function (flight) {
                    var bound = flight.bound;
                    return flight.options.brand.offer[bound].totalPrice.tax
                        + flight.options.brand.offer[bound].totalPrice.obFee;
                }).reduce(function (a, b) { return a + b; });
            }
        }
        else {
            totalTax = selectedFlights.map(function (flight) { return (flight.options.tax); }).reduce(function (a, b) { return a + b; });
        }
        return totalTax;
    };
    /**
     *	Computes and returns the total cash discount without regard to which part of the booking total each individual discount is applicable
     */
    INDRAFlightPriceService.prototype.computeDiscountsTotal = function (promocodesAndVouchers, bookedTripDiscounts, weakFlightsDiscount, flightFare, flightTax) {
        var totalDiscount = 0;
        if (promocodesAndVouchers && promocodesAndVouchers.length > 0) {
            for (var i in promocodesAndVouchers) {
                if (promocodesAndVouchers[i].currencyCode !== 'M') {
                    if (promocodesAndVouchers[i].type === DISCOUNT_TYPE_PROMOCODE &&
                        promocodesAndVouchers[i].amountType === DISCOUNT_AMOUNT_TYPE_PERCENTAGE) {
                        if (flightFare > 0) { // disregard percentage promocode when 0 flightfare (means no selected flight yet)
                            /*
                            const actualDiscountAmount = promocodesAndVouchers[i].applyTo === DISCOUNT_APPLY_TO_TOTAL ?
                                ((flightFare + flightTax) * (promocodesAndVouchers[i].amount/100)) : (flightFare  * (promocodesAndVouchers[i].amount/100));
                            totalDiscount = totalDiscount + actualDiscountAmount;
                            */
                            totalDiscount = totalDiscount + promocodesAndVouchers[i].actualValue;
                        }
                    }
                    else {
                        if (promocodesAndVouchers[i].type === DISCOUNT_TYPE_PROMOCODE) {
                            totalDiscount = totalDiscount + promocodesAndVouchers[i].actualValue;
                        }
                        else {
                            totalDiscount = totalDiscount + promocodesAndVouchers[i].amount;
                        }
                    }
                }
            }
        }
        if (bookedTripDiscounts && bookedTripDiscounts.length > 0) {
            for (var i in bookedTripDiscounts) {
                totalDiscount = totalDiscount + parseFloat(bookedTripDiscounts[i].value);
            }
        }
        if (weakFlightsDiscount && weakFlightsDiscount.amount) {
            totalDiscount = totalDiscount + parseFloat(weakFlightsDiscount.amount);
        }
        return totalDiscount;
    };
    /**
     *	Computes and returns the total miles discount without regard to which part of the booking total each individual discount is applicable
     */
    INDRAFlightPriceService.prototype.computeMilesDiscountsTotal = function (promocodesAndVouchers, bookedTripDiscounts, weakFlightsDiscount, flightPoints) {
        var totalDiscount = 0;
        if (promocodesAndVouchers && promocodesAndVouchers.length > 0) {
            for (var i in promocodesAndVouchers) {
                if (promocodesAndVouchers[i].currencyCode === 'M') {
                    if (promocodesAndVouchers[i].type === DISCOUNT_TYPE_PROMOCODE &&
                        promocodesAndVouchers[i].amountType === DISCOUNT_AMOUNT_TYPE_PERCENTAGE) {
                        if (flightPoints > 0) { // disregard percentage promocode when 0 flightfare (means no selected flight yet)
                            // const actualDiscountAmount = +((flightPoints * (promocodesAndVouchers[i].amount/100)).toFixed(0));
                            // totalDiscount = totalDiscount + actualDiscountAmount;
                            totalDiscount = totalDiscount + promocodesAndVouchers[i].actualValue;
                        }
                    }
                    else {
                        if (promocodesAndVouchers[i].type === DISCOUNT_TYPE_PROMOCODE) {
                            totalDiscount = totalDiscount + promocodesAndVouchers[i].actualValue;
                        }
                        else {
                            totalDiscount = totalDiscount + promocodesAndVouchers[i].amount;
                        }
                    }
                }
            }
        }
        return totalDiscount;
    };
    INDRAFlightPriceService.prototype.getDiscountTotalByType = function (discountType, amountType, applyTo, promocodesAndVouchers, bookedTripDiscounts, weakFlightsDiscount, isBookAwardFlights, flightFare, flightTax) {
        var totalDiscount = 0;
        switch (discountType) {
            case DISCOUNT_TYPE_VOUCHER:
                if (promocodesAndVouchers && promocodesAndVouchers.length > 0) {
                    for (var i in promocodesAndVouchers) {
                        if (promocodesAndVouchers[i].type === DISCOUNT_TYPE_VOUCHER) {
                            totalDiscount = totalDiscount + promocodesAndVouchers[i].amount;
                        }
                    }
                }
                break;
            case DISCOUNT_TYPE_PROMOCODE:
                var promocodeList = promocodesAndVouchers && promocodesAndVouchers.length > 0 ?
                    (isBookAwardFlights ? promocodesAndVouchers.filter(function (discount) { return discount.type === DISCOUNT_TYPE_PROMOCODE && discount.currencyCode === 'M'; }) :
                        promocodesAndVouchers.filter(function (discount) { return discount.type === DISCOUNT_TYPE_PROMOCODE && discount.currencyCode !== 'M'; })) : [];
                if (promocodeList.length > 0) {
                    switch (amountType) {
                        case DISCOUNT_AMOUNT_TYPE_FIXED:
                            var filteredByAmountTypeList = promocodeList.filter(function (discount) {
                                return discount.amountType === DISCOUNT_AMOUNT_TYPE_FIXED && discount.applyTo === applyTo;
                            });
                            if (filteredByAmountTypeList.length > 0) {
                                switch (applyTo) {
                                    case DISCOUNT_APPLY_TO_TOTAL:
                                        for (var i in filteredByAmountTypeList) {
                                            if (filteredByAmountTypeList[i].applyTo === DISCOUNT_APPLY_TO_TOTAL) {
                                                // totalDiscount = totalDiscount + filteredByAmountTypeList[i].amount;
                                                totalDiscount = totalDiscount + filteredByAmountTypeList[i].actualValue;
                                            }
                                        }
                                        break;
                                    case DISCOUNT_APPLY_TO_FARE:
                                        if (filteredByAmountTypeList && filteredByAmountTypeList.length > 0) {
                                            for (var i in filteredByAmountTypeList) {
                                                if (filteredByAmountTypeList[i].applyTo === DISCOUNT_APPLY_TO_FARE) {
                                                    // totalDiscount = totalDiscount + filteredByAmountTypeList[i].amount;
                                                    totalDiscount = totalDiscount + filteredByAmountTypeList[i].actualValue;
                                                }
                                            }
                                        }
                                        break;
                                    case DISCOUNT_APPLY_TO_YQ:
                                        if (filteredByAmountTypeList && filteredByAmountTypeList.length > 0) {
                                            for (var i in filteredByAmountTypeList) {
                                                if (filteredByAmountTypeList[i].applyTo === DISCOUNT_APPLY_TO_YQ) {
                                                    // totalDiscount = totalDiscount + filteredByAmountTypeList[i].amount;
                                                    totalDiscount = totalDiscount + filteredByAmountTypeList[i].actualValue;
                                                }
                                            }
                                        }
                                        break;
                                }
                            }
                            break;
                        // note: changed to avoid computation and just return the actualValue property
                        case DISCOUNT_AMOUNT_TYPE_PERCENTAGE:
                            switch (applyTo) {
                                case DISCOUNT_APPLY_TO_TOTAL:
                                    if (promocodeList.length > 0) {
                                        for (var i in promocodeList) {
                                            if (promocodeList[i].amountType === DISCOUNT_AMOUNT_TYPE_PERCENTAGE &&
                                                promocodeList[i].applyTo === DISCOUNT_APPLY_TO_TOTAL && flightFare > 0) {
                                                totalDiscount = totalDiscount + promocodeList[i].actualValue;
                                                /*
                                                if (promocodeList[i].currencyCode !== 'M') {
                                                    const actualDiscountAmount = (flightFare + flightTax) * (promocodeList[i].amount/100);
                                                    totalDiscount = totalDiscount + actualDiscountAmount;
                                                } else {
                                                    const actualDiscountAmount = +((flightFare * (promocodeList[i].amount/100)).toFixed(0));
                                                    totalDiscount = totalDiscount + actualDiscountAmount;
                                                }
                                                */
                                            }
                                        }
                                    }
                                    break;
                                case DISCOUNT_APPLY_TO_FARE:
                                    if (promocodeList.length > 0) {
                                        for (var i in promocodeList) {
                                            if (promocodeList[i].amountType === DISCOUNT_AMOUNT_TYPE_PERCENTAGE &&
                                                promocodeList[i].applyTo === DISCOUNT_APPLY_TO_FARE && flightFare > 0) {
                                                totalDiscount = totalDiscount + promocodeList[i].actualValue;
                                                /*
                                                if (promocodeList[i].currencyCode !== 'M') {
                                                    const actualDiscountAmount = flightFare  * (promocodeList[i].amount/100);
                                                    totalDiscount = totalDiscount + actualDiscountAmount;
                                                } else {
                                                    const actualDiscountAmount = +((flightFare * (promocodeList[i].amount/100)).toFixed(0));
                                                    totalDiscount = totalDiscount + actualDiscountAmount;
                                                }
                                                */
                                            }
                                        }
                                    }
                                    break;
                                case DISCOUNT_APPLY_TO_YQ:
                                    if (promocodeList.length > 0) {
                                        for (var i in promocodeList) {
                                            if (promocodeList[i].amountType === DISCOUNT_AMOUNT_TYPE_PERCENTAGE &&
                                                promocodeList[i].applyTo === DISCOUNT_APPLY_TO_YQ && flightFare > 0) {
                                                totalDiscount = totalDiscount + promocodeList[i].actualValue;
                                                /*
                                                if (promocodeList[i].currencyCode !== 'M') {
                                                    const actualDiscountAmount = flightFare  * (promocodeList[i].amount/100);
                                                    totalDiscount = totalDiscount + actualDiscountAmount;
                                                } else {
                                                    const actualDiscountAmount = +((flightFare * (promocodeList[i].amount/100)).toFixed(0));
                                                    totalDiscount = totalDiscount + actualDiscountAmount;
                                                }
                                                */
                                            }
                                        }
                                    }
                                    break;
                            }
                            break;
                    }
                }
                break;
            case DISCOUNT_TYPE_OTHERS:
                if (bookedTripDiscounts && bookedTripDiscounts.length > 0) {
                    for (var i in bookedTripDiscounts) {
                        totalDiscount = totalDiscount + parseFloat(bookedTripDiscounts[i].value);
                    }
                }
                if (weakFlightsDiscount && weakFlightsDiscount.amount) {
                    totalDiscount = totalDiscount + parseFloat(weakFlightsDiscount.amount);
                }
                break;
            default: break;
        }
        return totalDiscount;
    };
    INDRAFlightPriceService.prototype.INDRA_getOtherChargesTotal = function () {
        var adminFee = 0;
        var userData = this.storage.get('userData');
        if (userData == null) {
            if (this.router.url.includes('/review-your-trip') || this.router.url.includes('/booking/payment') || this.router.url.includes('/time-to-think') || this.router.url.includes('/extras-to-your-trip')) {
                var pnrDetails = this.bfmStorage.originalPNRDetailsResponse;
                if (pnrDetails && pnrDetails.data.fare && pnrDetails.data.fare.originalFlightPrice &&
                    pnrDetails.data.fare.originalFlightPrice.totalPrice && pnrDetails.data.fare.originalFlightPrice.totalPrice.adminFee &&
                    pnrDetails.data.fare.originalFlightPrice.totalPrice.adminFee.amount) {
                    adminFee = pnrDetails.data.fare.originalFlightPrice.totalPrice.adminFee.amount;
                }
            }
        }
        return adminFee; // add other
    };
    INDRAFlightPriceService.prototype.INDRA_getAncillariesPaidWithMiles = function (ancillaries) {
        var ancillariesTotal = 0;
        var cashTotal = 0;
        if (ancillaries) {
            for (var i in ancillaries.itemsAdded) {
                if (ancillaries.itemsAdded[i].payWithMiles) {
                    ancillariesTotal = ancillaries.itemsAdded[i].points + ancillariesTotal;
                    cashTotal = +ancillaries.itemsAdded[i].price + cashTotal;
                }
            }
        }
        return { miles: ancillariesTotal, cash: cashTotal };
    };
    INDRAFlightPriceService.prototype.INDRA_getThirdPartyAncillaries = function (activeBooking, ancillaryExclusion) {
        if (ancillaryExclusion === void 0) { ancillaryExclusion = []; }
        var ancillariesTotal = 0;
        // TODO check if there is a better way
        if ((this.router.url.includes('/review-your-trip') ||
            this.router.url.includes('/booking/payment') ||
            this.router.url.includes('extras-to-your-trip')) &&
            activeBooking) {
            // danish fund
            if (!ancillaryExclusion.includes(EXTRAS_ANCILLARY_GUARANTEE_FUND) && activeBooking.danish_fund && activeBooking.danish_fund != null) {
                ancillariesTotal = ancillariesTotal + activeBooking.danish_fund[0].amount;
            }
            // carbon offset
            if (!ancillaryExclusion.includes(EXTRAS_ANCILLARY_CARBON_OFFSET) && activeBooking.carbon_offset && activeBooking.carbon_offset != null) {
                ancillariesTotal = ancillariesTotal + activeBooking.carbon_offset[0].amount;
            }
            // insurance
            if (!ancillaryExclusion.includes(EXTRAS_ANCILLARY_INSURANCE) && activeBooking.insurance && activeBooking.insurance != null) {
                ancillariesTotal = ancillariesTotal + activeBooking.insurance[0].amount;
            }
            // rent-a-car
            if (!ancillaryExclusion.includes(EXTRAS_ANCILLARY_CAR) && activeBooking.rented_car && activeBooking.rented_car.length != 0) {
                var rentedCarTotal = 0;
                for (var i in activeBooking.rented_car) {
                    rentedCarTotal = rentedCarTotal + activeBooking.rented_car[i].payload.product.price.total.amount;
                }
                ancillariesTotal = ancillariesTotal + rentedCarTotal;
            }
        }
        return ancillariesTotal;
    };
    INDRAFlightPriceService.prototype.INDRA_getFlightFareBreakdown = function () {
        return this.flightFareBreakdown;
    };
    /**
     * Stores the flight fare breakdown - for booking confirmation view.
     * @param {any} fareBreakdown - breakdown from fare breakdown api response
     * @param {any} summary - total for each breakdown
     */
    INDRAFlightPriceService.prototype.INDRA_setFlightFareBreakdown = function (fareBreakdown, summary, currency) {
        this.flightFareBreakdown = { fareBreakdown: fareBreakdown, summary: summary, currency: currency };
    };
    INDRAFlightPriceService.prototype.INDRA_getFlightPriceByFareBreakdown = function (breakdown) {
        var totalFare = 0;
        var totalTax = 0;
        var currencyCode = Object.keys(breakdown)[0];
        var currencyUnit = this.currencyService.INDRA_getCurrencySymbol(currencyCode).unit;
        var breakdownItemsList = Object.getOwnPropertyNames(breakdown[currencyCode]);
        breakdownItemsList.forEach(function (item) {
            var paxCount = breakdown[currencyCode][item].totalPassengers;
            totalFare += breakdown[currencyCode][item].basePrice * paxCount;
            totalTax += breakdown[currencyCode][item].tax * paxCount;
        });
        return { flightPrice: totalFare, tax: totalTax, currencyUnit: currencyUnit };
    };
    INDRAFlightPriceService.prototype.removeDecimalPlaces = function (numStr) {
        var decimalPointIdx = numStr.indexOf('.');
        var finalNumStr;
        if (decimalPointIdx > 0) {
            finalNumStr = numStr.substring(0, numStr.indexOf('.'));
        }
        else {
            finalNumStr = numStr;
        }
        return finalNumStr;
    };
    INDRAFlightPriceService.prototype.INDRA_convertToCorrectDecimalPlace = function (priceStr) {
        var decimalPlace = this.currencyService.INDRA_getDecimalPlaces();
        return (decimalPlace > 0 ? priceStr : this.removeDecimalPlaces(priceStr));
    };
    INDRAFlightPriceService.prototype.isFlightCostZero = function (flightCost, discount) {
        return (flightCost - discount) <= 0 ? true : false;
    };
    INDRAFlightPriceService.ngInjectableDef = i0.defineInjectable({ factory: function INDRAFlightPriceService_Factory() { return new INDRAFlightPriceService(i0.inject(i1.INDRACurrencyService), i0.inject(i2.INDRABFMDataStorageService), i0.inject(i3.INDRAStorageService), i0.inject(i4.Router)); }, token: INDRAFlightPriceService, providedIn: "root" });
    return INDRAFlightPriceService;
}());
export { INDRAFlightPriceService };
